import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

export default function BtnImprimir({
    pdfFileURI
}: BtnImprimirProps) {

    const handleDownloadPDF = () => {
        window.open(pdfFileURI, '_blank');
    };

    return (
        <Button
            startIcon={<PrintIcon />}
            variant="contained"
            onClick={handleDownloadPDF}
        >
            Imprimir boleto
        </Button>
    )
}
interface BtnImprimirProps {
    pdfFileURI: string
}